<div>
    <input v-if="singleInput" :disabled="disabled" :ref="`single-input-${id}`" :placeholder="placeholder" />
    <slot v-else/>
</div>